import PropTypes from "prop-types";

import componentType from "./react.proptypes";
import connectedComponentType from "./react-redux.proptypes";

const reactChildrenType = PropTypes.oneOfType([
  componentType,
  connectedComponentType,
]);

export default reactChildrenType;
